import BAR from '../resources/images/BAR.png';
import TABLE_TOP_LT from '../resources/images/TABLE_TOP_LT.png';
import TABLE_TOP_EN from '../resources/images/TABLE_TOP_EN.png';
import GREASE_FILTER from '../resources/images/GREASE_FILTER.png';
import COOLING_COUNTER_LT from '../resources/images/COOLING_COUNTER_LT.png';
import COOLING_COUNTER_EN from '../resources/images/COOLING_COUNTER_EN.png';

import T1VIDEO from '../resources/video/TASK1.mp4';
import T2VIDEO from '../resources/video/TASK2.mp4';

import PDF_LT_1 from '../resources/pdf/PDF_LT_1.pdf';
import PDF_LT_2 from '../resources/pdf/PDF_LT_2.pdf';
import PDF_LT_3 from '../resources/pdf/PDF_LT_3.pdf';
import PDF_LT_4 from '../resources/pdf/PDF_LT_4.pdf';

import PDF_EN_1 from '../resources/pdf/PDF_EN_1.pdf';
import PDF_EN_2 from '../resources/pdf/PDF_EN_2.pdf';
import PDF_EN_3 from '../resources/pdf/PDF_EN_3.pdf';
import PDF_EN_4 from '../resources/pdf/PDF_EN_4.pdf';

import TERMS_LT from '../resources/pdf/TERMS_LT.pdf';
import TERMS_EN from '../resources/pdf/TERMS_EN.pdf';

export const UNDEFINED = 'undefined';
export const COUNTRY_OPTIONS = [ { key: 'lt', value: 'lithuanian', text: 'LT' }, { key: 'gb', value: 'united kingdom', text: 'EN' }  ]
export const LITHUANIAN_LANGUAGE = 'lithuanian';
export const UNITED_KINGDOM_LANGUAGE = 'united kingdom';
export const LANGUAGE = {
    lt: {
        back_button_label: "Grįžti atgal",
        information_label: "DALYVAUK IR LAIMĖK",
        information_label_2: "STIPENDIJĄ",
        information_label_3: "METAMS!",
        tasks_label: "Užduotys",
        tasks_header_label: "UŽDUOTYS:",
        time_left_label: "IKI KONKURSO LIKO:",
        days_label: "Dienos",
        hours_label: "Valandos",
        minutes_label: "Minutės",
        seconds_label: "Sekundės",
        prize_label: "SVEIKINAME",
        prize_label_2: "NUGALĖTOJUS!",
        place_label: "vieta",
        first_place_number: "I",
        first_place_number_label: "st",
        first_place_header_label: "2400 €",
        first_place_subheader_label: "200 €/mėn",
        first_place_winner: "Stewen Naano",
        second_place_number: "II",
        second_place_number_label: "nd",
        second_place_header_label: "444 €",
        second_place_subheader_label: "Vienkartinė stipendija",
        second_place_winner: "Dovydas Vatiekūnas",
        third_place_number: "III",
        third_place_number_label: "rd",
        third_place_header_label: "333 €",
        third_place_subheader_label: "Vienkartinė stipendija",
        third_place_winner: "Povilas Piartli",
        partners_label: "PARTNERIAI:",
        watch_video_label: "Žiūrėti video įrašą",
        questions_label: "Turite klausimų?",
        subject_label: "Su konkursu susijęs klausimas",
        company_label: 'UAB „Novameta“',
        address_label: "Draugystės g. 15D, LT-51227 Kaunas, Lietuva",
        phone_label: "+370 37 30 23 30",
        mail_label: "novameta@novameta.lt",
        T1_link: "http://nextcloud.novameta.lt/index.php/s/RjmCmab4aCTs9be",
        T2_link: "http://nextcloud.novameta.lt/index.php/s/ydqgAdwKe4DRibt",
        T3_link: "http://nextcloud.novameta.lt/index.php/s/C9H97RDJr8Q9TcG",
        T4_link: "http://nextcloud.novameta.lt/index.php/s/2oAJ3f8mgqJKSTM",
        form_container: {
            about_heading: "Apie konkursą",
            about_paragraph: ["Didžiausias nerūdijančio plieno gamintojas Šiaurės Europoje, gaminantis baldus ir įrangą profesionalioms virtuvėms. Savo kokybe ir inovatyvumu gavęs pripažinimą iš tokių pasaulinio lygio kompanijų kaip „Google“, Bentley“, Microsoft“, „Hilton“, „Marriot“, „Nato“, „Rolls Royce“, „Calsberg“ ir „Samsung“.", "Prasidėjus 2018 m. Rudens semestrui, UAB „Novameta“ pirmą kartą pristato, studentams skirtą konkursą „Novameta Talentas 2018“. Konkursas – tai naujų idėjų kūrimo skatintojas, organizuojamas UAB „Novameta“, kuriuo siekiama inicijuoti naujų idėjų kūrimą.", "Susipažink su užduotimis nuo rugsėjo 20 d. ir teik atsakymus nuo spalio 1 d.", "Aplikuok iki lakpkričio 5d.", "Laimėk. Nugalėtojai bus skelbiami lapkričio 12d."],
            T1_header: "Projektavimo užduotis",
            T1_video: T1VIDEO,
            T1_pdf: PDF_LT_1,
            T1_subheader_1: "Stalviršio sustiprinančios medžiagos parinkimas ir konstrukcijos tobulinimas",
            T1_description_header: "Aprašymas:",
            T1_description_paragraph: ["Stalviršio išorė, pagaminta iš 1 mm storio nerūdijančio plieno lakšto AISI 304."],
            T1_task_header: "Užduotis:",
            T1_task_paragraph: ["Parinkti alternatyvią sustiprinančiąją medžiagą stalviršio vidinei daliai ir aprašyti stalviršio sustiprinimo operaciją."],
            T1_requirements_header: "Reikalavimai:",
            T1_requirements_paragraph: ["Stalviršis atsparus drėgmei;", "Ant stalviršio statomi puodai, įkaitę iki 200 °C temperatūros, medžiaga turi atlaikyti nurodytą momentinę temperatūrą;", "Stalviršio sustiprinimo operacija trunka < 60 min;", "Maksimali tolygiai paskirstyta apkrova 120 kg;", "Svoris < 670 kg/m³."],
            T1_image: TABLE_TOP_LT,
            T2_header: "Technologinė užduotis",
            T2_video: T2VIDEO,
            T2_pdf: PDF_LT_2,
            T2_subheader_1: "Riebalų filtro surinkimo spartinimas",
            T2_description_header: "Aprašymas:",
            T2_description_paragraph: ["Riebalų gaudyklė - tai komplektuojanti gaubtų (gartraukių) dalis. Jos paskirtis išvalyti į ventiliacijos sistemą traukiamą orą nuo riebalų (aliejaus) ir vandens garų bei kvapų. Garai kondensuojasi ant sumontuotų pertvarkų ir dėl pasirinktos formos nuteka žemyn į specialius latakus gaubte;", "Filtrai surenkami naudojant elektrovaržinį litavimą bei taškinį virinimą;", "Virinamos vietos po virinimo nušveičiamos vieliniu šepečiu;", "Surinkimas trunka 9.5 min."],
            T2_task_header: "Užduotis:",
            T2_task_paragraph: ["Sutrumpinti riebalų filtro surinkimo laiką keičiant konstrukciją arba surinkimo procesą;", "Aprašyti technologijos pakeitimus jei reikia, nubraižyti pasikeitusios konstrukcijos brėžinius."],
            T2_requirements_header: "Reikalavimai:",
            T2_requirements_paragraph: ["Filtrus komplektuojančios dalys gaminamos iš 0.8 mm storio AISI 430 nerūdijančio plieno lakšto skardos;", "Naujos įrangos atsiperkamumo įvertinimas (esant poreikiui)."],
            T2_image: GREASE_FILTER,
            T3_header: "Esamo produkto tobulinimas",
            T3_video: undefined,
            T3_pdf: PDF_LT_3,
            T3_subheader_1: "Šaldymo stalas ATEITIES VIRTUVEI",
            T3_description_header: undefined,
            T3_description_paragraph: undefined,
            T3_task_header: "Užduotis:",
            T3_task_paragraph: ["Patobulinyi inovatyvų šaldomą stalą profesionaliai virtuvei, išlaikant dabartines gaminio savybes. Tai gali būti tiek dizaino, tiek funkcinis, tiek technologinis bei ergonominis sprendimas."],
            T3_requirements_header: undefined,
            T3_requirements_paragraph: undefined,
            T3_image: COOLING_COUNTER_LT,
            T4_header: "Kūrybinė užduotis",
            T4_video: undefined,
            T4_pdf: PDF_LT_4,
            T4_subheader_1: "Profesionali baro, restorano, kavinės ar viešbučio ateities virtuvė ar tokios virtuvės gaminys",
            T4_description_header: undefined,
            T4_description_paragraph: undefined,
            T4_task_header: "Užduotis:",
            T4_task_paragraph: ["Pateikti inovatyvią idėją profesionaliam baro, restorano, kavinės ar viešbučio ateities virtuvės gaminiui ir ją vizualizuoti."],
            T4_requirements_header: undefined,
            T4_requirements_paragraph: undefined,
            T4_image: BAR,
            task_info_header: "Užduoties pateikimo informacija:",
            task_rules_label: "Nuostatai",
            task_rules_agree: "Aš sutinku su nuostatais",
            task_terms: TERMS_LT,
            task_info_paragraph: ["Užduotys turi būti pateiktos suarchyvuotame dokumente (.zip, .rar, .7zip ...) ;", "Dokumentas turi būti pavadinas tokiu formatu: Vardas_Pavardė_Telefonas_ElektroninisPaštas. Pavyzdys: Jonas_Jonauskas_861231231_jonas@jonas.lt.rar ."],
            back_to_top_button_label: "Atgal į viršų",
            download_button_label: "Atsisiųsti šią užduotį",
            submit_button_label: "Pateikti užduotį",
            not_checked_alert: "Oi... Atrodo, jog užmiršote sutikti su konkurso nuostatais."
        }
    },
    gb: {
        back_button_label: "Go back",
        information_label: "PARTICIPATE AND WIN",
        information_label_2: "SCHOLARSHIP",
        information_label_3: "FOR WHOLE YEAR!",
        tasks_label: "Tasks",
        tasks_header_label: "TASKS:",
        time_left_label: "CONTEST STARTS IN:",
        days_label: "Days",
        hours_label: "Hours",
        minutes_label: "Minutes",
        seconds_label: "Seconds",
        prize_label: "CONGRATULATIONS",
        prize_label_2: "TO THE WINNERS!",
        place_label: "place",
        first_place_number: 1,
        first_place_number_label: "st",
        first_place_header_label: "2400 €",
        first_place_subheader_label: "200 €/month",
        first_place_winner: "Stewen Naano",
        second_place_number: 2,
        second_place_number_label: "nd",
        second_place_header_label: "444 €",
        second_place_subheader_label: "Fixed reward",
        second_place_winner: "Dovydas Vatiekūnas",
        third_place_number: 3,
        third_place_number_label: "rd",
        third_place_header_label: "333 €",
        third_place_subheader_label: "Fixed reward",
        third_place_winner: "Povilas Piartli",
        partners_label: "PARTNERS:",
        watch_video_label: "Watch the video",
        questions_label: "Have some questions?",
        subject_label: "Constest related question",
        company_label: "Novameta",
        address_label: "Draugystės st. 15D, LT-51227 Kaunas, Lithuania",
        phone_label: "+370 37 30 23 30",
        mail_label: "novameta@novameta.lt",
        T1_link: "http://nextcloud.novameta.lt/index.php/s/RjmCmab4aCTs9be",
        T2_link: "http://nextcloud.novameta.lt/index.php/s/ydqgAdwKe4DRibt",
        T3_link: "http://nextcloud.novameta.lt/index.php/s/C9H97RDJr8Q9TcG",
        T4_link: "http://nextcloud.novameta.lt/index.php/s/2oAJ3f8mgqJKSTM",
        form_container: {
            about_heading: "About contest",
            about_paragraph: ["The largest and most advanced manufacturer of stainless-steel commercial kitchen equipment in Northern Europe. High quality and innovative solutions were recognized by worldwide famous companies like Google, Bentley, Microsoft, Hilton, Marriot, Rolls Royce, Carlsberg and Samsung.", "This year Novameta will present for the first time an engineering and design competition for students Novameta Talent 2018. Four tasks which represent the actual challenges of our fast-growing company and allows to erupt and realize student’s knowledge and creativity, as well as get them familiar with real labor market needs, were carefully selected by Novameta team . The best solutions will be rewarded.", "Explore tasks from 20th of September;", "Apply till 5th of November;", "WIN. Winners will be announced on 12th of November."],
            T1_header: "Design assignment",
            T1_video: T1VIDEO,
            T1_pdf: PDF_EN_1,
            T1_subheader_1: "Table top reinforcement material selection and improvement of construction",
            T1_description_header: "Description:",
            T1_description_paragraph: ["Table top external part is manufactured from 1 mm thick AISI 304 stainless steel."],
            T1_task_header: "Task:",
            T1_task_paragraph: ["Choose alternative reinforcing material for table top internal part and describe table top reinforcement operation."],
            T1_requirements_header: "Requirements:",
            T1_requirements_paragraph: ["Table top should be resistant to water;", "Pots heated up to 200 °C are placed on the table top; material should be heat resistant to instantaneous temperature;", "Duration of table top reinforcement operation < 60 min;", "Equally distributed load 120 kg;", "Weight < 670 kg/m³."],
            T1_image: TABLE_TOP_EN,
            T2_header: "Manufacturing assignment",
            T2_video: T2VIDEO,
            T2_pdf: PDF_EN_2,
            T2_subheader_1: "Speeding up the grease filter assembly operation",
            T2_description_header: "Description:",
            T2_description_paragraph: ["Grease filter is an assembly part of exhaust hood. The filter is designed to extract heat and fumes from grease, as well as water and smell. The vapour condenses on the special plates and draws down into a special gutters in the hood;", "Filters are assembled using electrostatic soldering and spot welding;", "Welded spots are mechanically cleaned with a metal brush;", "Duration of current assembly is 9.5 min."],
            T2_task_header: "Task:",
            T2_task_paragraph: ["Reduce filters assembly time by changing construction or assembly process;", "Describe the changes in the assembly technology, if needed make drawings of the changed design."],
            T2_requirements_header: "Requirements:",
            T2_requirements_paragraph: ["Filter parts are made of 0.8 mm AISI 430 stainless steel sheet;", "New equipment cost assessment (if required)."],
            T2_image: GREASE_FILTER,
            T3_header: "Improvement of existing product",
            T3_video: undefined,
            T3_pdf: PDF_EN_3,
            T3_subheader_1: "Cooling counter for Future Kitchen",
            T3_description_header: undefined,
            T3_description_paragraph: undefined,
            T3_task_header: "Task:",
            T3_task_paragraph: ["Improve an innovative cooling counter for professional kitchen. It can be either design, functional, technological or ergonomic solution."],
            T3_requirements_header: undefined,
            T3_requirements_paragraph: undefined,
            T3_image: COOLING_COUNTER_EN,
            T4_header: "Creative assignment",
            T4_video: undefined,
            T4_pdf: PDF_EN_4,
            T4_subheader_1: "Creative offer of your choice",
            T4_description_header: undefined,
            T4_description_paragraph: undefined,
            T4_task_header: "Task:",
            T4_task_paragraph: ["Create an innovative idea for professional bar, restaurant cafe or hotel future kitchen product."],
            T4_requirements_header: undefined,
            T4_requirements_paragraph: undefined,
            T4_image: BAR,
            task_info_header: "Task submit information:",
            task_rules_label: "Terms",
            task_rules_agree: "I agree with the terms",
            task_terms: TERMS_EN,
            task_info_paragraph: ["Task must be presented in an archive document (.zip, .rar, .7zip ...) ;", "Document must be named according to such formatting: Name_Surname_Phone_Email. Example: John_Smith_861231231_email@email.com.rar ."],
            back_to_top_button_label: "Back to top",
            download_button_label: "Download this task",
            submit_button_label: "Sumbit task",
            not_checked_alert: "Ups... It looks like you have forgotten to agree with contest terms."            
        }

    }
}


// WEBPACK FOOTER //
// ./src/constants/AppConstants.js